import script from "./BrowserInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowserInstructions.vue?vue&type=script&setup=true&lang=js"

import "./BrowserInstructions.vue?vue&type=style&index=0&id=3d77a61e&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d77a61e"]])

export default __exports__